import * as angular from 'angular';
import { config } from 'angular/utils/config';

(function () {
    'use strict';

    angular.module('app').constant('API_URL', {
        // different API_URLs for different resources
        SCRATCH_MOCKS: 'http://localhost:8080',
        NETWORK_POINTS: `${config.monolithApi}/networkPoints/`,
        PROPOSAL: `${config.monolithApi}/proposal`,
        NETWORK_POINTS_FILE: 'http://localhost:63342/poc/netpoints.json/',
        USER: `${config.monolithApi}/user/authenticate`,
        REGISTRATION: `${config.monolithApi}/registration/`,
        TSO: `${config.monolithApi}/tso/:id`,
        EXCHANGE_RATES: `${config.monolithApi}/exchange-rates`,
        SHIPPERS: `${config.monolithApi}/shippers`,
        MARKET_MESSAGES: `${config.monolithApi}/marketMessages`,
        SHIPPER_USER: `${config.monolithApi}/shipperUsers`,
        TRADER_LISTS: `${config.monolithApi}/shippers/`,
        ACTIVITY: `${config.monolithApi}/activities`,
        AUCTIONS: `${config.monolithApi}/auctions`,
        FCFS: `${config.monolithApi}/fcfs`,
        SURRENDER: `${config.monolithApi}/surrender`,
        REPORTS: `${config.monolithApi}/reports`,
        SECONDARY_TRADE: `${config.monolithApi}/secondary-trade`,
        COLUMN_FILTER: `${config.monolithApi}/columnFilter`,
        STATIC_DATA: `${config.monolithApi}/resources`,
        XML_UPLOAD: `${config.monolithApi}/product-upload`,
        TRADE_AND_TRADE_PROPOSAL: `${config.monolithApi}/secondary-trade-and-trade-proposal`,
        SHIPPER_ADMIN: `${config.monolithApi}/shipperAdmin`,
        SSOSETTINGS: `${config.monolithApi}/sso-settings`,
        CAPACITY_LINKING: `${config.monolithApi}/linking`,
        STORAGE_LOCATION: `${config.monolithApi}/storage-location`,
        STORAGE_FCFS_OFFER: `${config.monolithApi}/storage-fcfs-offer`,
        STORAGE_FCFS_REQUEST: `${config.monolithApi}/storage-fcfs-request`,
        STORAGE_FCFS_RESPONSE: `${config.monolithApi}/storage-fcfs-response`,
        STORAGE_FCFS_CONFIRMATION: `${config.monolithApi}/storage-fcfs-confirmation`,
        EVENT_STATISTICS: `${config.monolithApi}/event-statistics`
    });
})();
